import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudflareService } from '../../service';

export type Require2faConfig = typeof Require2faConfig._.Config;

export const Require2faConfig = IntegrationConfig.make({
  service: CloudflareService,
  name: Integration_Handler_Names_Enum.Require_2fa,
  configSchema: z.object({
    accountId: z.string().min(1),
  }),
});
